import {Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {MainComponent} from "./main/main.component";
import {ProductHeaderComponent} from "./products/product-header.component";
import {ProductDetailComponent} from "./products/product-detail.component";
import {ProductSkuSlotsComponent} from "./products/product-sku-slots/product-sku-slots.component";
import {OrgUnitMasterComponent} from "./organization/org-unit-master.component";
import {OrganizationDetailComponent} from "./organization/organization-detail.component";
import {OrganizationAddressesComponent} from "./organization/organization-addresses.component";
import {OrganizationPhonesComponent} from "./organization/organization-phones.component";
import {OrganizationEmailsComponent} from "./organization/organization-emails.component";
import {CustomerPoliciesComponent} from "./organization/customer-policies.component";
import {PersonHeaderComponent} from "./person/person-header.component";
import {PersonDetailComponent} from "./person/person-detail.component";
import {PersonRolesComponent} from "./person/person-roles.component";
import {PersonGroupsComponent} from "./person/person-groups.component";
import {PersonAdminDelegationComponent} from "./person/person-admin-delegation.component";
import {QuoteMasterComponent} from "./quote/quote-master.component";
import {OrderMasterComponent} from "./orders/order-master.component";
import {QuoteDetailComponent} from "./quote/quote-detail.component";
import {OrderDetailComponent} from "./orders/order-detail.component";
import {OrderReleaseComponent} from "./orders/release/order-release.component";
import {OpportunityMasterComponent} from "./opportunity/opportunity-master.component";
import {OpportunityDetailComponent} from "./opportunity/opportunity-detail.component";
import {FpaManagementComponent} from "./fpa/fpa-management.component";
import {SfrManagementComponent} from "./sfr/sfr-management.component";
import {DocumentManagementComponent} from "./documents/document-management.component";
import {MyContactsComponent} from "./contacts/my-contacts.component";
import {TrainingComponent} from "./training/training.component";
import {MarketingComponent} from "./marketing/marketing.component";
import {PersonDelegationComponent} from "./person/person-delegation.component";
import {CancellationRequestTaskComponent} from "./tasks/cancellation-request-task.component";
import {ComplexityTaskComponent} from "./tasks/complexity-task.component";
import {CreditExceptionsTaskComponent} from "./tasks/credit-exceptions-task.component";
import {PartsShipDateTaskComponent} from "./tasks/parts-ship-date-task.component";
import {TaxStatusRequestTaskComponent} from "./tasks/tax-status-request-task.component";
import {UserApplicationComponent} from "./person/user-application.component";
import {SabrComponent} from "./sabr/sabr.component";
import {ProjectDefaultsComponent} from "./projectDefaults/project-defaults.component";
import {RiserChartComponent} from "./riser/riser-chart/riser-chart.component";
import {ReleaseSummaryComponent} from "./orders/release/release-summary.component";
import {RecentReleasesComponent} from "./orders/release/recent-releases.component";
import {ConfiguratorComponent} from "./configurator/configurator.component";
import {TaskResponseComponent} from "./task-response/task-response.component";
import {CustomerFurnishedPartsRequiredComponent} from "./tasks/customer-furnished-parts-required/customer-furnished-parts-required.component";
import {ScheduleDetailComponent} from "./schedules/schedule-detail/schedule-detail.component";
import {RatingsHomeComponent} from "./ratings/ratings-home/ratings-home.component";
import {RatingsToolComponent} from "./ratings/ratings-tool/ratings-tool.component";
import {SelectionToolComponent} from "./ratings/selection-tool/selection-tool.component";
import {UnitListComponent} from "./ratings/unit-list/unit-list.component";
import {ProjectListComponent} from "./ratings/project-list/project-list.component";
import {RatingsDocumentationComponent} from "./ratings/ratings-documentation/ratings-documentation.component";
import {WorkingSureFlowLoopsComponent} from "./sureflow/working-sure-flow-loops/working-sure-flow-loops.component";
import {UnitDetailComponent} from "./ratings/unit-detail/unit-detail.component";
import {WorkingSureFlowUnitComponent} from "./sureflow/working-sure-flow-unit/working-sure-flow-unit.component";
import {AutoCostReportComponent} from "./autoCost/auto-cost-report/auto-cost-report.component";
import {EntityCostReportComponent} from "./skuCost/entity-cost-report/entity-cost-report.component";
import {EntitySureFlowLoopsComponent} from "./sureflow/entity-sure-flow-loops/entity-sure-flow-loops.component";
import {EntitySureFlowUnitComponent} from "./sureflow/entity-sure-flow-unit/entity-sure-flow-unit.component";
import {SureflowEntityUnitConfiguratorComponent} from "./sureflow/sureflow-entity-unit-configurator/sureflow-entity-unit-configurator.component";
import {UnauthorizedComponent} from "./unauthorized.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {QuickUnitPricingComponent} from "./quick-unit-pricing/quick-unit-pricing.component";
import { FpaTaskResponseComponent } from './fpa-task-response/fpa-task-response.component';
import { SnBypassTaskResponseComponent } from './sn-bypass-task-response/sn-bypass-task-response.component';

export const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'main', component: MainComponent},
  {path: 'product', component: ProductHeaderComponent},
  {path: 'product/:product-id', component: ProductDetailComponent},
  {path: 'product/:productId/skuSlots', component: ProductSkuSlotsComponent},
  {path: 'organization', component: OrgUnitMasterComponent},
  {path: 'organization/:organization-id', component: OrganizationDetailComponent},
  {path: 'organization/addresses/:organization-id', component: OrganizationAddressesComponent},
  {path: 'organization/phones/:organization-id', component: OrganizationPhonesComponent},
  {path: 'organization/emails/:organization-id', component: OrganizationEmailsComponent},
  {path: 'organization/policies/:organization-id', component: CustomerPoliciesComponent},
  {path: 'person', component: PersonHeaderComponent},
  {path: 'person/:person-id', component: PersonDetailComponent},
  {path: 'person/roles/:person-id', component: PersonRolesComponent},
  {path: 'person/groups/:person-id', component: PersonGroupsComponent},
  {path: 'person/delegations/:person-id', component: PersonAdminDelegationComponent},
  {path: 'quotes', component: QuoteMasterComponent},
  {path: 'orders', component: OrderMasterComponent},
  {path: 'quotes/:quote-id/:quote-revision', component: QuoteDetailComponent},
  {path: 'orders/:entity-id/:entity-revision', component: OrderDetailComponent},
  {path: 'orderRelease/:entity-id/:entity-revision', component: OrderReleaseComponent},
  {path: 'opportunities', component: OpportunityMasterComponent},
  {path: 'opportunities/:opportunity-id/:opportunity-revision', component: OpportunityDetailComponent},
  {path: 'fpa/:entity-type/:entity-id/:entity-revision', component: FpaManagementComponent},
  {path: 'sfrManagement/:entity-id/:entity-revision', component: SfrManagementComponent},
  {path: 'documents/:entity-type/:entity-id/:entity-revision', component: DocumentManagementComponent},
  {path: 'main/myContacts', component: MyContactsComponent},
  {path: 'main/training', component: TrainingComponent},
  {path: 'main/marketing', component: MarketingComponent},
  {path: 'userDelegation', component: PersonDelegationComponent},
  {path: 'cancellationRequestTask/:task-id', component: CancellationRequestTaskComponent},
  {path: 'complexityCategoryTask/:task-id', component: ComplexityTaskComponent},
  {path: 'creditExceptionsTask/:task-id', component: CreditExceptionsTaskComponent},
  {path: 'partShipDateTask/:task-id', component: PartsShipDateTaskComponent},
  {path: 'taxStatusRequestTask/:task-id', component: TaxStatusRequestTaskComponent},
  {path: 'userApplication', component: UserApplicationComponent},
  {path: 'sabrSummary/:folderNumber/:entityId/:customerId', component: SabrComponent},
  {path: 'projectDefaults/:entity-name/:entity-id/:entity-revision', component: ProjectDefaultsComponent},
  {path: 'riserChart/:entity-name/:entity-id/:entity-revision', component: RiserChartComponent},
  {path: 'releaseSummary/:entity-id/:entity-revision', component: ReleaseSummaryComponent},
  {path: 'recentReleases/:org-unit-id', component: RecentReleasesComponent},
  {path: 'configurator/:entityType/:entityId/:entityRevision', component: ConfiguratorComponent},
  {path: 'fpaTaskResponse/:taskId', component: FpaTaskResponseComponent},
  {path: 'snBypassTaskResponse/:taskId', component: SnBypassTaskResponseComponent},
  {path: 'taskResponse/:taskId', component: TaskResponseComponent},
  {path: 'customerFurnishedPartsRequired/:taskId', component: CustomerFurnishedPartsRequiredComponent},
  {path: 'schedules', pathMatch: 'full', redirectTo: 'ratings/projectList'},
  {path: 'schedules/:id', component: ScheduleDetailComponent},
  {
    path: 'ratings',
    component: RatingsHomeComponent,
    children: [
      {path: '', pathMatch: 'full', redirectTo: 'ratingTool'},
      {path: 'ratingTool', component: RatingsToolComponent},
      {path: 'selectionTool', component: SelectionToolComponent},
      {path: 'unitList', component: UnitListComponent},
      {path: 'projectList', component: ProjectListComponent},
      {path: 'documentation', component: RatingsDocumentationComponent},
      {path: 'sureflowLoops', pathMatch: 'full', redirectTo: 'sureflowLoops/0'},
      {path: 'sureflowLoops/:loopId', component: WorkingSureFlowLoopsComponent},
    ]
  },
  {path: 'rating/unitDetail/:unitId', component: UnitDetailComponent},
  {path: 'rating/scheduleUnitDetail/:scheduleId/:lineId', component: UnitDetailComponent},
  {path: 'rating/sureFlowUnit/:loopId/:unitId', component: WorkingSureFlowUnitComponent},
  {path: 'entityCostReport/:entityId/:entityRevision', component: EntityCostReportComponent},
  {path: 'autoCostReport/:entityId/:entityRevision', component: AutoCostReportComponent},
  {path: ':entityName/sureflow/loops/:entityId/:entityRevision', component: EntitySureFlowLoopsComponent},
  {path: ':entityName/sureflow/unit/:unitId', component: EntitySureFlowUnitComponent},
  {path: 'sureflow/unit/configure', component: SureflowEntityUnitConfiguratorComponent},
  {path: 'quickUnitPricing', component: QuickUnitPricingComponent},
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: '**', component: PageNotFoundComponent},
];
